// Functions to import various components from the CDN

function appendCacheBusting(url) {
  let date = new Date();
  let oneHourCache = date.getMonth()+1+""+date.getDate()+""+date.getFullYear()+""+date.getHours();
  return `${url}?v=${oneHourCache}`;
}
function appendOneDayCacheBusting(url) {
  let date = new Date();
  let oneDayCache = date.getMonth()+1+""+date.getDate()+""+date.getFullYear();
  return `${url}?v=${oneDayCache}`;
}
export function safeImportComponent(componentURL, bustCache = true) {
  let isScript = componentURL.includes(".js");
  let isStyling = componentURL.includes(".css");

  if (!isScript && !isStyling) {
    console.error(`Component type not recognized for file: ${componentURL}`);
    return;
  }

  var headElement = document.getElementsByTagName("head")[0];
  if (document.getElementById(componentURL)) {
    // This component has already been pulled
    return;
  }

  let cacheBustedURL = componentURL;
  if (bustCache) {
    cacheBustedURL = appendCacheBusting(componentURL);
  }

  var newElement = null;
  if (isScript) {
    if (bustCache) {
      cacheBustedURL = appendCacheBusting(componentURL);
    }
    newElement = document.createElement("script");
    newElement.src = cacheBustedURL;

    // Ensure enterprise-search script loads synchronously so custom element is defined before use
    if (componentURL.includes('enterprisesearch')) {
      newElement.defer = false;
      newElement.async = false;
      newElement.onload = function() {
        if (!customElements.get('enterprise-search')) {
          console.error('[componentImportUtils] Enterprise search bundle loaded but custom element was not registered.');
        }
      };
      newElement.onerror = function(err) {
        console.error('[componentImportUtils] Failed to load enterprise search bundle:', err);
      };
    } else {
      newElement.defer = true;
    }
  } else if (isStyling) {

    newElement = document.createElement("link");
    newElement.type = "text/css";
    newElement.rel = "stylesheet";
    if (bustCache) {
      cacheBustedURL = appendOneDayCacheBusting(componentURL);
    }
    newElement.href = cacheBustedURL;
  }
  // ID is without cache busting
  newElement.id = componentURL;

  headElement.appendChild(newElement);
}

export function renamePlatformCategory(platformCategory) {
  return platformCategory === "HR" ? "AskHR" : platformCategory;
}
